import axios from "axios";
import { deleteApi, getApi, postApi } from "../configAxios";

export const getCitizenRequests = (params) => {
  return getApi("/admin/citizen-requests", {
    page: params.page,
    per_page: params.per_page,
    request_type: params.request_type,
    status: params.status,
    search: params.search,
  });
};

export const getCitizenRequestDetails = (id) => {
  return getApi(`/admin/citizen-requests/${id}`);
};

export const updateCitizenRequestStatus = (id, data) => {
  return postApi(`/admin/citizen-requests/${id}/status`, data);
};

export const deleteCitizenRequest = (id) => {
  return deleteApi(`/admin/citizen-requests/${id}`);
};
